import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { PracticeLocationsState } from 'src/app/states/practice-locations-state.service';
import { FetchPracticeLocations } from 'src/app/states/practice-locations.actions';
import { catchError, filter, map, of, take, timeout } from 'rxjs';
import { CurrentAccountState } from 'src/states';
import { NavigateToForbidden } from 'src/app/states/navigations.actions';

export const manifestDependenciesGuard: CanActivateFn = () => {
  const store = inject(Store);

  const isPscSwitched = store.selectSnapshot(CurrentAccountState.isPscSwitched);
  const isPscLocation = store.selectSnapshot(CurrentAccountState.isPscLocationType);

  // Manifests are not available for a PSC jumped-to account; direct links (e.g. bookmarks) go to Forbidden instead of a blank page.
  if (isPscSwitched) {
    return store.dispatch(new NavigateToForbidden()).pipe(map(() => false));
  }

  if (isPscLocation) {
    return of(true);
  }

  if (!store.selectSnapshot(PracticeLocationsState.loaded)) {
    store.dispatch(new FetchPracticeLocations());
  }

  return store.select(PracticeLocationsState.loaded).pipe(
    filter(loaded => loaded),
    map(() => true),
    timeout(30000),
    take(1),
    catchError(() => of(false))
  );
};
